import React, { useEffect, useRef, useState } from "react";
import { JobSearch, post } from "../../config/imagesLink";
import { ShimmerThumbnail } from "react-shimmer-effects";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import JobAction from "./JobAction";
import axios from "../../API/axios";
import { getUserConfig } from "../../Services/apiService";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import ModalForGuest from "../ModalForGuest";
import { JobCardSkeleton } from "@skeleton";
import JobApply from "./JobApply";
import JobStatusBadges from "../../components/JobStatusBadges";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import AutoAwesomeSharpIcon from "@mui/icons-material/AutoAwesomeSharp";
import BookmarkBorderSharpIcon from "@mui/icons-material/BookmarkBorderSharp";
import BookmarkSharpIcon from "@mui/icons-material/BookmarkSharp";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import GoogleAdUnit from "../../components/GoogleAdUnit";
import ViewToggle from "./ViewToggle";
import SortDropdown from "./SortDropdown";

const JobList = ({
  reset,
  filterJobList,
  setReset,
  jobsList,
  setJobsList,
  getAllJobList,
  totalPages,
  setTotalPages,
  page,
  setSearchValue,
  searchValue,
  isLoading,
  isError,
  hasMoreData,
  nextBatchLoading,
  refContainer,
  hideSearchBar = false,
}) => {
  const [viewMode, setViewMode] = useState('grid');
  const [sortBy, setSortBy] = useState('newest');
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const userUid = localStorage.getItem("userUid");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const { t } = useTranslation();
  const language = localStorage.getItem("Lang");
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [bookmarkModal, setBookmarkModal] = useState(false);
  const closeModalData = () => {
    setBookmarkModal(false);
  };

  //************************Save job End  ************************//
  const [savedJobs, setSavedJobs] = useState(new Set());

  const saveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/SaveJob`, responseData).then((res) => {
        setToastMessage(res.data.message);
        setShowToast(true);
        setSavedJobs((prev) => new Set(prev).add(jobId));
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Save job End  ************************//

  //************************UnSave job start  ************************//
  const unsaveJob = async (jobId) => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      jobId: jobId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`JobAction/UnSaveJob`, responseData).then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllJobList();
        // setIsSaved(false);
        setSavedJobs((prev) => {
          const newSavedJobs = new Set(prev);
          newSavedJobs.delete(jobId);
          return newSavedJobs;
        });
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************UnSave job End  ************************//

  //************************Apply and Unapply job  ************************//
  const [isappliedF, setIsappliedF] = useState(false);
  const [appliedId, setAppliedId] = useState("");
  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleCloseModal = () => setShowAppliedModal(false);
  const handleShow = () => setShowAppliedModal(true);
  const [appliedJobId, setAppliedJobId] = useState("");

  //************************Apply and Unapply job  ************************//

  //************************User Profile Stats Start  ************************//
  // const [userPer, setUserPer] = useState([]);
  // const getUserProfilePer = () => {
  //   const data = {
  //     deviceType: "Web",
  //     sessionId: sessionId,
  //   };
  //   axios
  //     .post(`UserProfile/GetProfilePercentage`, data)
  //     .then((response) => {
  //       // console.log("userprofilestat", response.data.responseData);
  //       const res = response.data.responseData;
  //       setUserPer(res);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };
  // useEffect(() => {
  //   getUserProfilePer();
  // }, [sessionId]);

  const [profileConfig, setProfileConfig] = useState([]);
  const navigate = useNavigate();
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const userConfig = async () => {
    try {
      const responseData = await getUserConfig();
      setProfileConfig(responseData);
    } catch (error) {
      if (
        (error.code === "ERR_NETWORK" && sessionId) ||
        (error.code === "ERR_BAD_REQUEST" && sessionId)
      ) {
        setUnauthorisedModal(true);
      }
    }
  };

  useEffect(() => {
    const sessionId = localStorage.getItem("sessionId");

    if (sessionId) {
      (async () => {
        await Promise.all([
          userConfig(),
        ]);
      })();
    }
  }, []);

  const [userCcv, setUserCcv] = useState("");
  const AddUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`Ccv/AddUserCcv`, data).then((resData) => {
        // console.log('resData', resData.data.responseData);
        setUserCcv(resData.data.responseData);
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************User Profile Stats End  ************************//

  useEffect(() => {
    if (showAppliedModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showAppliedModal]);

  // console.log("jobsList", jobsList);

  // .................................shortDescription
  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;

    const anchors = div.querySelectorAll('a');
    anchors.forEach(anchor => {
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
    });

    return div.innerHTML;
  };


  const linkifyContent = (htmlContent) => {
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const cleanShortDescription = (htmlString) => {
    return htmlString
      ?.replace(/<h3>/gi, "<div>")
      ?.replace(/<h2>/gi, "<div>")
      ?.replace(/<\/h3>/gi, "</div>")
      ?.replace(/<strong>/gi, "")
      ?.replace(/<\/strong>/gi, "");
  };


  const sortJobs = (jobs) => {
    const jobsCopy = [...jobs];
    switch (sortBy) {
      case 'oldest':
        return jobsCopy.sort((a, b) => new Date(a.creationTime) - new Date(b.creationTime));
      case 'expiring-soon':
        return jobsCopy.sort((a, b) => Number(a.expiringInDays) - Number(b.expiringInDays));
      case 'relevance':
        return jobsCopy.sort((a, b) => {
          const titleA = a.title.toLowerCase();
          const titleB = b.title.toLowerCase();
          return titleA.localeCompare(titleB);
        });
      case 'newest':
      default:
        return jobsCopy.sort((a, b) => new Date(b.creationTime) - new Date(a.creationTime));
    }
  };

  const getPostListWithAds = (posts) => {
    const result = [];
    posts.forEach((post, index) => {
      result.push(post);
      if ((index + 1) % 12 === 0) {
        result.push({ isAd: true });
      }
    });
    return result;
  };
  const sortedJobs = sortJobs(jobsList);
  const postsWithAds = getPostListWithAds(sortedJobs);
  const isInitialLoad = isLoading && (!jobsList || jobsList.length === 0);
  const showPaginationLoader = nextBatchLoading && hasMoreData && !isLoading;

  return (
    <div className="job-list-panel">
      {!hideSearchBar && (
        <div className="row job-header">
          <div className="col-md-12">
            <div className="job-search-toolbar">
              <div className="search-container flex-grow-1">
                <SearchSharpIcon className="material-symbols-sharp" />
                <div className="search-input-container">
                  <input
                    type="text"
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                    value={searchValue}
                    placeholder={t("SearchJob.Search")}
                    className="search-input"
                  />
                </div>
              </div>
              <Link to="/SearchJob/Recommendations" state={{ from: "jobs" }} className="job-recommendation-btn">
                <AutoAwesomeSharpIcon className="job-recommendation-icon" />
                <span>{t("Recommendations.Recommendations")}</span>
              </Link>
            </div>
          </div>
        </div>
      )}

      <div className="row job-controls-header">
        <div className="col-md-12">
          <div className="job-search-controls">
            <SortDropdown sortBy={sortBy} setSortBy={setSortBy} />
            <ViewToggle viewMode={viewMode} setViewMode={setViewMode} />
          </div>
        </div>
      </div>

      <div
        className={`row job-list-grid ${viewMode === 'list' ? 'job-list-view' : ''}`}
        id="job-list-container"
        ref={refContainer}
      >
        {isInitialLoad ? (
          <JobCardSkeleton count={3} />
        ) : isError ? (
          <div className="mt-2 error-image-cont error-image-job">
            <img src={post.errorSmall} alt="404 Not Found" width={200} />
          </div> 
        ) : (
          <>
            {postsWithAds
              ?.filter((item) => !item.isDeleted)
              .map((item, index) => {
                const now = moment();
                const itemTime = moment.utc(item?.creationTime);
                const duration = moment.duration(now.diff(itemTime));

                const years = duration.years();
                const months = duration.months();
                const days = duration.days();
                const hours = duration.hours();
                const minutes = duration.minutes();

                let result = '';
 
                 if (years > 0) {
                  result = `${years} ${t("Notifications.Year")}${years > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (months > 0) {
                  result = `${months} ${t("Notifications.Month")}${months > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (days > 0) {
                  result = `${days} ${t("Notifications.Day")}${days > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (hours > 0) {
                  result = `${hours} ${t("Notifications.Hour")}${hours > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else if (minutes > 0) {
                  result = `${minutes} ${t("Notifications.Minute")}${minutes > 1 ? 's' : ''} ${t("Notifications.Ago")}`;
                } else {
                  result = t("Notifications.Just Now");
                }

                return (
                  <React.Fragment key={item.isAd ? `ad-${index}` : `job-${item.jobId}`}>
                    {item.isAd && (
                      <div className="col-12 job-list-inline-ad">
                        <div className="advertiseImage">
                          <div className="advertisementview mb-0">
                            <div
                              className="advertisementContainer"
                              style={{
                                width: "100%",
                                height: "180px",
                                overflow: "hidden",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <GoogleAdUnit
                                key={`job-ad-${index}`}
                                adSlot="9135916775"
                                style={{
                                  display: "block",
                                  width: "100%",
                                  height: "100%",
                                  margin: "0 auto",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {!item.isAd && (
                      <div className={`${viewMode === 'list' ? 'col-12' : 'col-lg-4 col-md-6'} d-flex align-items-stretch mt-3 IncreaseWidthJobCard`}>
                        <div className="jobCard p-3 w-100 d-flex flex-column justify-content-between">
                          <div>
                            <div
                              className="d-flex justify-content-start align-items-center job-company-row"
                              style={{ height: "60px" }}
                            >
                          <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`}>
                              {/* <Link to={`/Company/${item.compUid}`}> */}
                                <div className="pointer d-flex">
                                  <img
                                    src={item?.compLogo}
                                    alt={`${item.compName} logo`}
                                    className="job-company-logo"
                                    title={item.compName}
                                  />
                                </div>
                              </Link>
                              <Link to={item.slug ? `/Company/${item.compUid}/${item.slug}` : `/Company/${item.compUid}`} className="job-company-link d-flex align-items-center">
                                <span className="job-company-name" title={item.compName}>
                                  {item.compName}
                                </span>
                                {item.isVerified ? (
                                  <VerifiedIcon sx={{ fontSize: 16, color: "#12B76A", marginLeft: "4px" }} titleAccess="Verified" />
                                ) : null}
                              </Link>
                              <div className="ms-auto">
                                <JobAction
                                  item={item}
                                  AllJobList={getAllJobList}
                                  setJobList={setJobsList}
                                  jobList={jobsList}
                                  totalPages={totalPages}
                                  setTotalPages={setTotalPages}
                                  page={page}
                                />
                              </div>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-2 emoji-container me-0">
                              <Link to={`/JobDetail/${item.jobId}`} className="job-title-link">
                                <p className="job-title pointer mb-0">
                                  {item.title}
                                </p>
                              </Link>

                              {savedJobs.has(item?.jobId) || item?.isSaved === true ? (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkSharpIcon
                                    className="material-symbols-sharp pointer job-bookmark-btn"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        unsaveJob(item?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                    title="Remove from saved jobs"
                                    aria-label="Remove from saved jobs"
                                    role="button"
                                    tabIndex="0"
                                  />
                                </div>
                              ) : (
                                <div className="d-flex align-items-center postAction">
                                  <BookmarkBorderSharpIcon
                                    className="material-symbols-outlined pointer job-bookmark-btn"
                                    onClick={() => {
                                      if (guestModeData !== "true") {
                                        saveJob(item?.jobId);
                                      }
                                    }}
                                    disabled={guestModeData === "true"}
                                    title="Save this job"
                                    aria-label="Save this job"
                                    role="button"
                                    tabIndex="0"
                                  />
                                </div>
                              )}
                            </div>

                            <p
                              className="short-Des-jobCard"
                              dangerouslySetInnerHTML={{
                                __html: cleanShortDescription(
                                  item.shortDescription?.length > 50
                                    ? item.shortDescription?.slice(0, 50) + "..."
                                    : item.shortDescription
                                ),
                              }}
                              style={{ fontSize: "13px", lineHeight: "1.5" }}
                            />
                            <div className="job-location">
                              <LocationOnOutlinedIcon />
                              <span>{item.cityName}</span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-2 job-card-foot">
                              <Tooltip title={moment.utc(item?.creationTime).local().format("DD MMM YYYY")} arrow>
                                <small aria-label={`Posted on ${moment.utc(item?.creationTime).local().format("DD MMM YYYY")}`}>
                                  <ScheduleOutlinedIcon />
                                  {t("Manage Job.Posted")} {result}
                                </small>
                              </Tooltip>
                              <div className="badge badge-date" aria-label={`${Number(item?.expiringInDays) < 0 ? 'expired' : 'expires in'} ${Number(item?.expiringInDays) < 0 ? Math.abs(Number(item?.expiringInDays)) : item?.expiringInDays} days`}>
                               {Number(item?.expiringInDays) < 0
                                  ? `${t("Manage Job.expired")} ${Math.abs(Number(item?.expiringInDays))} ${t("Manage Job.days Ago")}`
                                  : `${item?.expiringInDays} ${t("Manage Job.days Left")}`}
                              </div>
                            </div>

                            <div className="jobType">
                              {(item.matchScore != null || item.MatchScore != null) && (
                                <span className="badge badge-job badge-match">
                                  {Math.round(item.matchScore ?? item.MatchScore)}% match
                                </span>
                              )}
                              <div className="badge badge-job badge-job-type">
                                {item.jbTypName}
                              </div>
                              <div className="badge badge-job badge-job-location">
                                {item.workLocationTypeName}
                              </div>
                              <div className="badge badge-job badge-job-role">
                                {item.designationName}
                              </div>
                            </div>
                            <JobStatusBadges item={item} />
                          </div>
                          <div className="mt-auto">
                            <JobApply
                              isAppliedByYou={item?.isApplied}
                              jobId={item?.jobId}
                              getAllJobList={getAllJobList}
                              item={item}
                              profileConfig={profileConfig}
                              AddUserCcv={AddUserCcv}
                              userCcv={userCcv}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </>
        )}

        {showPaginationLoader && (
          <div className="text-center my-3">
            <img src={post?.loader} width={50} alt="" />
          </div>
        )}
        {!hasMoreData && jobsList.length > 12  && (
          <p className="text-center my-3 mb-0">{t("Newsfeed.No more data available")}</p>
        )}
         {/* {(page > 1 && !hasMoreData) &&(
                <p className="text-center my-3 mb-0">No more data available</p >
            )} */}
      </div>

      {bookmarkModal && <ModalForGuest closeModalData={closeModalData} />}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {showResumeModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>
                 {t("modals.Please complete your profile up to 60% and must have valid resume to  Create Company")}
                </h6>

                {/* <span
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShowResumeModal(false);
                  }}
                >
                  close
                </span> */}
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    setShowResumeModal(false);
                  }}
                />
              </div>
              <div className="text-center mt-2">
                <Link to={`/User/${userUid}`}>
                  <button
                    color=""
                    className="closebtn"
                    style={{ width: "150px" }}
                  // onClick={() => {
                  //   userCcv !== "True" && AddUserCcv();
                  // }}
                  >
                    Manage Profile
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {unauthorisedModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                  <p className="text-center ad-p">
                    {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue.")}
                  </p>
                  <div className="text-center m-auto mt-3">
                    <button
                      type="button"
                      className="mainBtn1 "
                      onClick={() => {
                        setUnauthorisedModal(!unauthorisedModal);
                        navigate("/SignIn");
                        localStorage.clear();
                        sessionStorage.removeItem("hasModalShown");
                      }}
                    >
                      {t("modals.login")} 
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobList;
